/* CLAIRENCE : popup code -10 %.
   S'affiche une seule fois par visite, apres 20 secondes passees sur le site (le compteur continue de page en page).
   Jamais sur le panier. Le formulaire est le formulaire natif Shopify "customer" : le contact est cree dans Clients,
   avec les tags "popup-clairence10" et "tel:+33...". Apres l'envoi, le code CLAIRENCE10 s'affiche et s'applique au paiement. */
(function () {
  "use strict";
  var root = document.getElementById("ClPopup");
  if (!root) { return; }

  var DELAY = parseInt(root.getAttribute("data-delay"), 10) || 20000;
  var CODE = root.getAttribute("data-code") || "CLAIRENCE10";
  var KEY = "clPopupV1";
  var T0 = "clPopupT0";
  var PENDING = "clPopupPending";
  var DAY = 86400000;

  var card = root.querySelector(".cl-pop__card");
  var form = root.querySelector("form");
  var phone = document.getElementById("ClPopupPhone");
  var tags = document.getElementById("ClPopupTags");
  var err = root.querySelector(".cl-pop__error");
  var formView = root.querySelector(".cl-pop__form-view");
  var okView = root.querySelector(".cl-pop__ok-view");
  var submitBtn = root.querySelector(".cl-pop__btn");
  var isOpen = false;
  var lastFocus = null;

  /* Stockage navigateur : toujours protege, la page fonctionne sans. */
  function store(kind, op, key, value) {
    try {
      var s = kind === "local" ? window.localStorage : window.sessionStorage;
      if (op === "get") { return s.getItem(key); }
      if (op === "set") { s.setItem(key, value); }
      if (op === "del") { s.removeItem(key); }
    } catch (e) { /* stockage indisponible */ }
    return null;
  }

  /* Ne pas reafficher : 3 jours apres une fermeture, 180 jours apres une inscription. */
  function suppressed() {
    var raw = store("local", "get", KEY);
    if (!raw) { return false; }
    try {
      var s = JSON.parse(raw);
      var age = Date.now() - s.t;
      return s.s === "sent" ? age < 180 * DAY : age < 3 * DAY;
    } catch (e) { return false; }
  }
  function remember(state) {
    store("local", "set", KEY, JSON.stringify({ s: state, t: Date.now() }));
  }

  /* Numero francais ou international : renvoie +33612345678, ou "" si invalide. */
  function normPhone(v) {
    var s = String(v || "").replace(/[\s.\-()]/g, "");
    if (/^00/.test(s)) { s = "+" + s.slice(2); }
    if (/^\+330/.test(s)) { s = "+33" + s.slice(4); }
    if (/^0\d{9}$/.test(s)) { s = "+33" + s.slice(1); }
    return /^\+\d{8,15}$/.test(s) ? s : "";
  }

  function showError(msg) {
    if (!err) { return; }
    err.textContent = msg;
    err.hidden = false;
  }

  function open() {
    if (isOpen) { return; }
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add("cl-pop-lock");
    window.requestAnimationFrame(function () {
      root.classList.add("is-in");
      if (card) { card.focus(); }
    });
  }

  function close() {
    if (!isOpen) { return; }
    isOpen = false;
    if (!okView || okView.hidden) { remember("closed"); }
    root.classList.remove("is-in");
    document.body.classList.remove("cl-pop-lock");
    window.setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* rien */ } }
  }

  function showSuccess() {
    if (formView) { formView.hidden = true; }
    if (okView) { okView.hidden = false; }
  }

  /* Active le code pour le paiement (lien de remise Shopify). */
  function applyDiscount() {
    try { window.fetch("/discount/" + encodeURIComponent(CODE), { credentials: "same-origin" }).catch(function () {}); } catch (e) { /* rien */ }
  }

  /* Ne pas ouvrir par-dessus le menu mobile ou la recherche. */
  function pageBusy() {
    var nav = document.getElementById("MobileNav");
    var search = document.getElementById("SearchPanel");
    return (nav && nav.classList.contains("is-open")) || (search && !search.hasAttribute("hidden"));
  }

  function tryOpen() {
    if (isOpen) { return; }
    if (document.visibilityState !== "visible") {
      document.addEventListener("visibilitychange", tryOpen, { once: true });
      return;
    }
    if (pageBusy()) { window.setTimeout(tryOpen, 3000); return; }
    open();
  }

  /* Evenements */
  root.querySelectorAll("[data-pop-close]").forEach(function (el) { el.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) {
    if (!isOpen) { return; }
    if (e.key === "Escape") { close(); return; }
    if (e.key === "Tab" && card) {
      var f = card.querySelectorAll("a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex='-1'])");
      var vis = [].filter.call(f, function (n) { return n.offsetParent !== null; });
      if (!vis.length) { return; }
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  if (form) {
    form.addEventListener("submit", function (e) {
      var p = normPhone(phone && phone.value);
      if (!p) {
        e.preventDefault();
        showError("Entrez un numéro de téléphone valide, par exemple 06 12 34 56 78.");
        if (phone) { phone.focus(); }
        return;
      }
      if (err) { err.hidden = true; }
      if (tags) { tags.value = "popup-clairence10,tel:" + p; }
      store("session", "set", PENDING, "1");
      remember("sent");
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Envoi en cours..."; }
    });
  }

  var copyBtn = root.querySelector("[data-pop-copy]");
  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      var done = function () { copyBtn.textContent = "Code copié"; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CODE).then(done, function () {});
      }
    });
  }

  /* Retour apres l'envoi du formulaire (Shopify recharge la page avec customer_posted=true). */
  var q = new URLSearchParams(window.location.search);
  if (store("session", "get", PENDING) === "1") {
    var serverError = root.getAttribute("data-error");
    if (q.get("customer_posted") === "true") {
      store("session", "del", PENDING);
      document.documentElement.classList.add("cl-pop-returned");
      q.delete("customer_posted");
      try {
        var qs = q.toString();
        window.history.replaceState(null, "", window.location.pathname + (qs ? "?" + qs : "") + window.location.hash);
      } catch (e) { /* rien */ }
      applyDiscount();
      showSuccess();
      open();
      return;
    }
    if (serverError) {
      store("session", "del", PENDING);
      showError(serverError);
      open();
      return;
    }
  }

  if (suppressed()) { return; }

  /* Compteur de visite : 20 secondes depuis la premiere page vue, toutes pages confondues. */
  var t0 = parseInt(store("session", "get", T0) || "0", 10);
  if (!t0) { t0 = Date.now(); store("session", "set", T0, String(t0)); }
  window.setTimeout(tryOpen, Math.max(0, DELAY - (Date.now() - t0)));
})();